import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ productProp, handleAddToCart }) => {
  return (
    <Card className="card">
      <CardMedia component="img" src={productProp.image} alt={productProp.name} />
      <CardContent>
        <Typography color="primary" variant="h5">
          {productProp.name}
        </Typography>
        <Typography color="text-secondary" variant="subtitle2">
          {productProp.category}
        </Typography>
        <Typography color="textSecondary" variant="subtitle2">
          ${productProp.cost}
        </Typography>
      </CardContent>
      <Rating
        name="read-only"
        precision={0.5}
        value={productProp.rating}
        readOnly
      ></Rating>
      <Button onClick={handleAddToCart} className="card-button" role="button" variant="contained" color="primary">
        ADD TO CART
      </Button>
    </Card>
  );
};

export default ProductCard;
